import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-ricorso-straordinario-presidenterep-view',
  templateUrl: './form-ricorso-straordinario-presidenterep-view.component.html',
  styleUrls: ['./form-ricorso-straordinario-presidenterep-view.component.css']
})
export class FormRicorsoStraordinarioPresidenterepViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
